import Joi from "joi";
import { Input } from "../form/validatedInput";
import { Select } from "../form/validatedSelect";
import { useEffect, useState } from "react";
import { RAGInput } from "./ragInput";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { MetricEditingState } from "./editMetric";
import { Dispatch } from "redux";
import { getSpecificMetric } from "../../store/futureSecurity/actions";
import Loader from "../global/loader";

type PropType = {
    metric: MetricDefinition,
    applyTo: { label: string, value: string },
    terminal: string,
}


export const ViewMetric: React.FC<PropType> = ({ metric, applyTo, terminal }) => {
    const dispatch: Dispatch<any> = useDispatch()
    const { validationError, isLoading, requestedMetric } = useSelector(
        (state: MainState) => ({
            validationError: state.futureSecurity.validationError,
            isLoading: state.futureSecurity.isLoadingMetricValues,
            requestedMetric: state.futureSecurity.viewMetricDetails
        }),
        shallowEqual
    );

    const getFormattedDate = (date: Date): string => {
        return date.toISOString().split("T")[0]; // Converts to YYYY-MM-DD
    };

    const getTodaysBeginning = (): Date => {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        tomorrow.setHours(0, 0, 0, 0);
        return tomorrow;
    };

    const startOfDay = getTodaysBeginning();

    const [dateError, setDateError] = useState<boolean>(false)
    const [metricChangeDetails, setMetricChangeDetails] = useState<MetricEditingState>({
        fromDate: getFormattedDate(startOfDay),
        fromTime: "0",
        value1: metric.value1,
        value2: metric.value2 ?? undefined,
        toTime: "",
        toDate: ""
    })

    useEffect(() => {
        // once a specific metric has returned data, overwrite the default
        setMetricChangeDetails((prev) => {
            const val1 = requestedMetric?.value1 || prev.value1
            const val2 = requestedMetric?.value2 || prev.value2
            return {
                ...prev,
                value1: val1,
                value2: val2

            }
        })
    }, [requestedMetric])

    useEffect(() => {
        if(metricChangeDetails.fromDate < getFormattedDate(new Date())) {
            setDateError(true)
            return
        }
        if(applyTo && applyTo.value) {
            setDateError(false)
            dispatch(getSpecificMetric(metric, applyTo.value, metricChangeDetails, terminal))
        }
    }, [metricChangeDetails.fromDate, metricChangeDetails.fromTime, metric.code, terminal, applyTo])



    const hoursOptions = Array.from({ length: 24 }, (_, i) => {
        const hour = i.toString().padStart(2, '0');

        return {
            value: hour,
            label: `${hour}:00`
        };
    });

    const hourSchema = Joi.string().required().pattern(/^([0-1]?[0-9]|2[0-3])$/);

    const minAllowedDate = getFormattedDate(startOfDay);
    const applyToString = applyTo ? `${applyTo.value.toLowerCase().includes(metric.groupType) ? `${applyTo.value}` : `${metric.groupType.charAt(0).toUpperCase() + metric.groupType.slice(1)} ${applyTo.value}`}` : ''


    return (
        <div>
            <h2>Viewing {metric.airport.slice(0,3)} - {metric.name} - {`${terminal !== "main" ? `${terminal} -` : ''}`} {applyToString}</h2>
            <h3><u>Target</u></h3>
            <p className="error-message">{dateError && "Dates cannot be in the past."}</p>
            <p className="error-message">{validationError && validationError}</p>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: "20px" }}>
                <div style={{ flex: 1, marginRight: '10px' }}>
                    <Input min={minAllowedDate} type="date" value={metricChangeDetails.fromDate} onChange={(v) => setMetricChangeDetails({ ...metricChangeDetails, fromDate: v })} schema={Joi.date()} label="Date" />
                </div>
                <div style={{ flex: 1, marginRight: '10px' }}>
                    <Select
                        label="Time (UTC)"
                        options={hoursOptions}
                        value={metricChangeDetails.fromTime}
                        schema={hourSchema}
                        onChange={(v) => setMetricChangeDetails({ ...metricChangeDetails, fromTime: v })}
                    />
                </div>
            </div>
            <Loader isLoading={isLoading} />
            {!isLoading && <RAGInput comparator={metric.comparator} metric={metricChangeDetails} onUpdate={setMetricChangeDetails} disabled={true} />}
            {validationError && <p className='error-message'>{validationError.message}</p>}
        </div>
    );
};